<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        
       <div class="card">
        
            <div class="card-body">
              <h5>{{this.currentLanguage ==='en'?'How to get additional images':'วิธีการรับภาพเพิ่มเติม กรณีที่เหมาไปแล้ว และค้นหาเพิ่มเติม ส่วนที่มองไม่เห็นใบหน้า'}}</h5>
              <hr>
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 100%;border-radius: 2em;"
                  src="../../assets/images/running/more-image-1.jpg"
                />
              </div>
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 100%;border-radius: 2em;"
                  src="../../assets/images/running/more-image-2.jpg"
                />
              </div>
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 100%;border-radius: 2em;"
                  src="../../assets/images/running/more-image-3.jpg"
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => `วิธีการรับภาพเพิ่มเติม | RUNRACE.IN.TH`),
      meta: [
        {
          name: `description`,
          content: computed(() => `วิธีการรับภาพเพิ่มเติม | RUNRACE.IN.TH`),
        },
        {
          name: `keywords`,
          content: computed(() => `เกี่ยวกับเรา,ระบบรับสมัครงานวิ่ง,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,runrace,runninghub`),
        }
        ],
     
    })
  },
   data() {
    return {
      currentLanguage: 'th',
    };
  },
  async mounted() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  }


};
</script>